import { LOAN_ACTIONS } from '../../Action/LoanAction/LoanAction';

const initialState = {
  loans: [],
  summary: null,
  loading: false,
  actionLoading: false,
};

const LoanReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAN_ACTIONS.FETCH_START:
      return { ...state, loading: true };
    case LOAN_ACTIONS.FETCH_SUCCESS:
      return { ...state, loading: false, loans: action.payload };
    case LOAN_ACTIONS.FETCH_FAIL:
      return { ...state, loading: false };
    case LOAN_ACTIONS.SET_SUMMARY:
      return { ...state, summary: action.payload };
    case LOAN_ACTIONS.ACTION_START:
      return { ...state, actionLoading: true };
    case LOAN_ACTIONS.ACTION_END:
      return { ...state, actionLoading: false };
    default:
      return state;
  }
};

export default LoanReducer;